// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1283":"60f744b4","9135":"4ce504b2"}[chunkId] + ".chunk.css";
};